var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealTimeJobTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.96 511.5c85.72 0 155.62-25.37 155.62-56.49s-69.9-56.49-155.62-56.49-155.62 25.36-155.62 56.49 69.9 56.49 155.62 56.49z",
    fill: "#daeafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.96 455.01c-59.02-69.91-168.72-197.35-167.75-288.54.45-42.47 16.78-84.76 48.98-116.96 32.68-32.68 75.71-49.01 118.77-49.01s86.12 16.33 118.77 49.01c32.2 32.2 48.53 74.49 48.98 116.96.97 91.19-108.7 218.63-167.75 288.54z",
    fill: "#ff4646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.96 264.94c53.26 0 96.69-43.43 96.69-96.69 0-53.23-43.43-96.69-96.69-96.69s-96.69 43.46-96.69 96.69c0 53.27 43.43 96.69 96.69 96.69z",
    fill: "#daeafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.93 276.14-36.25 9.72 25.2 94 36.22-9.72z",
    fill: "#daeafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.6 35.08c-73.56 0-133.2 59.61-133.2 133.17s59.64 133.2 133.2 133.2 133.2-59.64 133.2-133.2-59.64-133.17-133.2-133.17z",
    fill: "#2f5274"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.32 342.73-52.21 14c-4.31 1.16-6.89 5.61-5.73 9.92l27.01 100.83c4.99 18.68 24.38 29.85 43.03 24.86 18.68-5.02 29.85-24.38 24.86-43.06l-27.01-100.8c-1.16-4.31-5.64-6.92-9.95-5.75z",
    fill: "#ff4646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.89 95.57c-40.14 40.14-40.14 105.25 0 145.39 40.17 40.14 105.25 40.14 145.42 0 40.14-40.14 40.14-105.25 0-145.39-40.17-40.16-105.25-40.16-145.42 0z",
    fill: "#8bd7fa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m354.35 121.43c0-4.56 3.68-8.25 8.25-8.25 4.56 0 8.25 3.69 8.25 8.25v38.61h38.58c4.56 0 8.25 3.69 8.25 8.22 0 4.56-3.69 8.25-8.25 8.25h-46.83c-4.56 0-8.25-3.69-8.25-8.25z",
    fill: "#daeafa"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m200.63 263.53c-45.47-7.91-80.02-47.54-80.02-95.27 0-47.71 34.55-87.36 80.02-95.24-5.41-.94-10.97-1.45-16.67-1.45-53.4 0-96.69 43.28-96.69 96.69s43.29 96.69 96.69 96.69c5.7-.01 11.25-.49 16.67-1.42z",
    fill: "#c4d3e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m138.89 400.92c-63.98 7-110.55 28.57-110.55 54.08 0 31.21 69.68 56.49 155.62 56.49 5.64 0 11.2-.11 16.67-.31-78.12-3.03-138.95-27.01-138.95-56.18 0-21.37 32.68-39.97 80.9-49.55-1.22-1.5-2.47-3-3.69-4.53z",
    fill: "#c4d3e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m278.75 187.47c-2.41-12.67-2.41-25.74 0-38.44 3.71-19.59 13.15-38.3 28.29-53.46 6.09-6.09 12.78-11.28 19.84-15.51 13.69-8.22 28.89-12.98 44.31-14.26-16.44-1.36-33.14 1.19-48.56 7.68-11.88 5.02-23.05 12.39-32.74 22.08-8.45 8.45-15.14 18.03-20.04 28.23-13.41 28.03-13.41 60.89 0 88.89 4.9 10.23 11.59 19.79 20.04 28.26 9.89 9.86 21.26 17.32 33.42 22.34 15.22 6.29 31.66 8.76 47.88 7.43-15.48-1.3-30.7-6.07-44.42-14.34-7.03-4.22-13.66-9.35-19.73-15.42-15.14-15.15-24.58-33.86-28.29-53.48z",
    fill: "#7dc2e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m392.56 366.65c-.71-2.69.03-5.47 1.76-7.46 1.02-1.16 2.38-2.04 4-2.47l7.97-2.15-.88-3.29-12.3 3.29-7.99 2.15c-4.31 1.16-6.89 5.61-5.73 9.92l27.01 100.83c4.79 17.86 22.71 28.86 40.59 25.43-12.81-2.47-23.81-12.02-27.41-25.43z",
    fill: "#e63f3f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m378.62 300.49 14.48 54.09 12.3-3.29-14.17-52.92c-4.14.9-8.36 1.61-12.61 2.12z",
    fill: "#c4d3e1",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeJobTracking);
export default __webpack_public_path__ + "static/media/real-time-job-tracking.b24a922c626e90bc2a7bd692458c4656.svg";
export { ForwardRef as ReactComponent };